export const formatDate = (isoDate) => {
  const date = new Date(isoDate);
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return date.toLocaleDateString("en-GB", options).replace(",", "");
};


export function convertToDecimalHours(timeStr) {
    const [hh, mm, ss] = timeStr.split(':').map(Number);
    const totalHours = hh + (mm / 60) + (ss / 3600);
    return totalHours;
}